import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=9afdb4b4&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=ts&"
export * from "./PageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=9afdb4b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afdb4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9afdb4b4')) {
      api.createRecord('9afdb4b4', component.options)
    } else {
      api.reload('9afdb4b4', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=9afdb4b4&scoped=true&", function () {
      api.rerender('9afdb4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/components/PageHeader.vue"
export default component.exports